import React from 'react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_TOTAL, CHECKOUT_URL, PACK_IMAGE, PRICE, PRODUCT_NAME } from '../data/content';
export function OfferSection() {
  return <section id="oferta" aria-labelledby="oferta-titulo" className="scroll-mt-2 border-y-4 border-coral bg-blush" data-id="element-108" data-mp="8mdmfcb6rh3m">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-5" data-id="element-109" data-mp="dg8306vhvfyh">
        <p className="inline-block rounded-md bg-ink px-2 py-0.5 font-sub text-sm font-semibold leading-tight text-white" data-id="element-110" data-mp="icotv8u2w8f9">
          🔥 Oferta especial — Sistema completo 6 en 1
        </p>
        <h2 id="oferta-titulo" className="mt-2 font-display text-[1.5rem] font-extrabold leading-[1.1] tracking-tight text-ink sm:text-4xl" data-id="element-111" data-mp="rf7vjpm4oezx">
          Comienza hoy a estudiar enfermería de forma visual y avanza a tu ritmo.
        </h2>

        <Reveal className="mt-3 overflow-hidden rounded-2xl border-4 border-dashed border-ink bg-surface text-ink" data-id="element-112" data-mp="2y44epeksmznx">
          <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block bg-tint" data-id="element-113" data-mp="12ns193d008wj">
            <img src={PACK_IMAGE} alt={`${PRODUCT_NAME}: 6 tomos y 5 bonos incluidos`} className="block w-full" data-id="element-114" data-mp="sxp0ggzmxqnn" />
          </a>
          <div className="p-3" data-id="element-115" data-mp="ou0svyb06v2e">
            <p className="font-display text-sm font-extrabold uppercase leading-tight text-primary" data-id="element-116" data-mp="1lm4cqvrdtuva">
              {PRODUCT_NAME}
            </p>
            <p className="mt-0.5 font-display text-2xl font-extrabold leading-none" data-id="element-117" data-mp="1gnt4uqkndufp">
              6 Tomos + 5 Bonos
            </p>
            <p className="mt-1 text-xs font-semibold text-muted sm:text-sm" data-id="element-118" data-mp="1cnj01h8lda2f">
              🎁 Bonos valorados en{' '}
              <span className="line-through decoration-2" data-id="element-119" data-mp="169jb2gukw4t">{BONUS_TOTAL}</span>
            </p>

            <p className="mt-2 inline-block rounded-full bg-coral px-3 py-0.5 font-display text-xs font-extrabold uppercase text-white" data-id="element-120" data-mp="3sd3uvu96hj05">
              🔥 Oferta especial
            </p>
            <p className="mt-1 font-display text-5xl font-black leading-none text-coral sm:text-6xl" data-id="element-121" data-mp="3ts6gef8kn49c">
              <span className="text-2xl text-ink sm:text-3xl" data-id="element-122" data-mp="3ktbevggh2icd">Hoy:</span>{' '}
              {PRICE}
            </p>
            <p className="mt-1 text-xs font-semibold text-muted" data-id="element-123" data-mp="3oumxv34uc5bl">
              Pago único • Sin mensualidades • Acceso Digital
            </p>

            <CtaButton href={CHECKOUT_URL} external size="lg" className="mt-3" data-id="element-124" data-mp="3b1x9is1uaobb">
              🚀 Sí, quiero el sistema completo por {PRICE}
            </CtaButton>
            <p className="mt-2.5 text-xs font-semibold text-muted" data-id="element-125" data-mp="3163m2dml1aer">
              Acceso Inmediato • Garantía de 7 Días
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}